"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import ContactFormContactFormSection from "@/reusable_sections/forms/contact_form_contact_form_section";
export default function ContactLocation() {
  const {
    ref: infoRef,
    isVisible: isInfoVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="contactform" className="bg-white relative overflow-hidden text-foreground ![padding:30px_0px_30px_0px]">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-[#9E0911]/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-[#62751D]/5 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={infoRef} className={`max-w-4xl mx-auto transition-all duration-700 delay-200 transform ${isInfoVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <ContactFormContactFormSection />
        </div>
      </div>
    </section>;
}